module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/facebook_messenger-7eb4f111d3ba90c9a14acd3ed6a089d6.png";